// document.querySelector('.collection-discover-btn-normal').addEventListener('click', function() {
//     // Select the sections
//     const featuresSection = document.querySelector('.colleciton-features-class');
//     const historySection = document.querySelector('.colleciton-history-class');

//     // Toggle the 'visible' class
//     featuresSection.classList.toggle('visible');
//     historySection.classList.toggle('visible');
// });



// document.addEventListener('DOMContentLoaded', function() {
//     // Select all button wrappers
//     const buttonWrappers = document.querySelectorAll('.collection-discover-btn-normal');

//     buttonWrappers.forEach(wrapper => {
//         const textElement = wrapper.querySelector('.collection-discover-btn-normal-text');
        
//         // Add click event to the entire wrapper
//         wrapper.addEventListener('click', function(e) {
//             // Toggle the button text and class
//             if (textElement.innerText.includes("Discover More")) {
//                 textElement.innerText = "See Less";
//                 wrapper.classList.add("see-less-class");
//             } else {
//                 textElement.innerText = "Discover More";
//                 wrapper.classList.remove("see-less-class");
//             }
//         });
//     });
// });



// document.querySelector('.collection-discover-history-btn').addEventListener('click', function() {
//     // Select the sections
//     const buttonWrappers2 = document.querySelectorAll('.collection-discover-btn-normal');
    
//     const featuresSection = document.querySelector('.colleciton-features-class');
//     const historySection = document.querySelector('.colleciton-history-class');

//     // Toggle the 'visible' class
//     featuresSection.classList.remove('visible');
//     historySection.classList.remove('visible');

//     buttonWrappers2.forEach(wrapper => {
//         const textElement = wrapper.querySelector('.collection-discover-btn-normal-text');
//         textElement.innerText = "Discover More";
//         wrapper.classList.remove("see-less-class");
//     })
// });

document.addEventListener('DOMContentLoaded', function() {
    // Select all elements we need
    const buttonWrappers = document.querySelectorAll('.collection-discover-btn-normal');
    const historyButton = document.querySelector('.collection-discover-history-btn');
    const featuresSection = document.querySelector('.colleciton-features-class');
    const historySection = document.querySelector('.colleciton-history-class');

    // Function to reset all sections and buttons
    const resetAll = () => {
        featuresSection.classList.remove('visible');
        historySection.classList.remove('visible');
        
        buttonWrappers.forEach(wrapper => {
            const textElement = wrapper.querySelector('.collection-discover-btn-normal-text');
            textElement.innerText = "Discover More";
            wrapper.classList.remove("see-less-class");
        });
    };

    // Add click handlers to normal buttons
    buttonWrappers.forEach(wrapper => {
        wrapper.addEventListener('click', () => {
            const textElement = wrapper.querySelector('.collection-discover-btn-normal-text');
            const isExpanding = textElement.innerText.includes("Discover More");

            // Toggle text and class
            textElement.innerText = isExpanding ? "See Less" : "Discover More";
            wrapper.classList.toggle("see-less-class", isExpanding);

            // Toggle sections
            featuresSection.classList.toggle('visible');
            historySection.classList.toggle('visible');
        });
    });

    // Add click handler to history button
    historyButton.addEventListener('click', resetAll);
});

